/**
 * 해지 (웹에서만, 2026-11-02 대표님: 요금제 화면에 해지 버튼을 두지 않고 자주 묻는 질문에서 이 화면으로 잇는다)
 * - 해지는 언제든, 이번 기간 끝까지 쓰고 다음 결제부터 청구하지 않는다. 체험 중에 해지하면 결제하지 않는다(공통/요금제와결제).
 * - "해지 전에 필요한 장부를 출력해 두세요" 안내 한 줄(2026-10-31 사용자).
 * - 소장님 계정만. 앱에서는 받지 않는다.
 */
import { useEffect, useState } from 'react';
import { api, type Who } from '../api.ts';
import { Button, Link, Message, Page } from '../ui.tsx';
import type { PlanInfo } from './Plan.tsx';

export function Cancel(props: { who: Who; go: (p: string) => void; refresh: () => Promise<void> }) {
  const [info, setInfo] = useState<PlanInfo | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    const r = await api<PlanInfo>('GET', '/api/plan');
    if (r.ok) setInfo(r);
    else setError(r.message);
  }

  useEffect(() => {
    void load();
  }, []);

  async function set(plan_next: string) {
    const r = await api('POST', '/api/plan/next', { plan_next });
    setError(r.ok ? null : r.message);
    await props.refresh();
    await load();
  }

  if (props.who.role !== '소장님') {
    return <Page title="해지"><p>해지는 소장님 계정만 할 수 있어요.</p><Link to="/" go={props.go}>처음 화면</Link></Page>;
  }
  if (!info) return <Page title="해지"><Message text={error} /></Page>;
  const s = info.state;
  const reserved = s.plan_next === '해지';

  return (
    <Page title="해지">
      <p>해지 전에 필요한 장부를 출력해 두세요.</p>
      {reserved ? (
        <>
          <p>해지 예약 중이에요. 이번 기간이 끝나면 이용이 멈춰요.</p>
          <Button onClick={() => void set(s.plan)}>해지 취소</Button>
        </>
      ) : (
        <>
          <p>{s.service_status === '체험 중' ? '체험 중에 해지하면 결제하지 않아요.' : '이번 기간 끝까지 쓰고 다음 결제부터 청구하지 않아요.'}</p>
          <Button onClick={() => void set('해지')}>해지</Button>
        </>
      )}
      <Message text={error} />
      <p><Link to="/plan" go={props.go}>요금제</Link></p>
    </Page>
  );
}
